/**
 * Move video modal to body
 */

const videoModals = document.querySelectorAll('tpt-live-modal');

videoModals.forEach((modal) => {
	document.body.prepend(modal);
});

/**
 * Check to active video playing
 * @param {*} currentVideo
 * @param {*} productVideos
 * @returns
 */

var checkPlayingInterval;

function checkItemPlaying(currentVideo, productVideos) {
	var interval = setInterval(function () {
		let indexProduct = 0;
		let flag = false;

		const currentVideoTime = currentVideo.currentTime;

		productVideos.forEach((product, index) => {
			const productTimeStart = parseInt(product.getAttribute('data-time-item-start'));

			if (currentVideoTime >= productTimeStart) {
				indexProduct = index;
				flag = true;
			}
		});

		if (flag) {
			if (!productVideos[indexProduct].classList.contains('playing')) {
				productVideos.forEach((product) => {
					product.classList.remove('playing');
				});

				productVideos[indexProduct].classList.add('playing');

				/**
				 * Update product active on mobile
				 */

				const currentModal = currentVideo.closest('tpt-live-modal');
				const activeItemMobile = currentModal.querySelector('tpt-product-mobile-video');

				const activeItemImage = currentModal.querySelector('.playing tpt-live-item-content .tpt-product-live_image');
				const activeItemInfo = currentModal.querySelector('.playing tpt-live-item-content .tpt-product-live_info');
				const activeItemId = currentModal.querySelector('.playing tpt-live-item-content').getAttribute('data-product-id');
				const activeItemAjaxurl = currentModal.querySelector('.playing tpt-live-item-content').getAttribute('data-product-url');

				const videoStartConfig = currentModal.querySelector('.playing tpt-live-item-content').getAttribute('data-video-start-config');
				const videoStart = currentModal.querySelector('.playing tpt-live-item-content').getAttribute('data-video-item-start');
				const videoId = currentModal.querySelector('.playing tpt-live-item-content').getAttribute('data-video-id');

				const mobileImageElement = currentModal.querySelector('.tpt-product-live__mobile-image');
				const mobileInfoElement = currentModal.querySelector('.tpt-product-live__mobile-info');

				if (activeItemImage && activeItemInfo) {
					mobileImageElement.innerHTML = activeItemImage.innerHTML;
					mobileInfoElement.innerHTML = activeItemInfo.innerHTML;

					activeItemMobile.setAttribute('data-product-id', activeItemId);
					activeItemMobile.setAttribute('data-product-url', activeItemAjaxurl);

					activeItemMobile.setAttribute('data-video-start-config', videoStartConfig);
					activeItemMobile.setAttribute('data-video-item-start', videoStart);
					activeItemMobile.setAttribute('data-video-id', videoId);
				}
			}
		}

		if (currentVideo.ended) {
			clearInterval(interval);
		}
	}, 1000);

	return interval;
}

/**
 * Reset video modal
 * @param {*} videoModal
 */
function resetVideoModal(videoModal) {
	const video = videoModal.querySelector('video');
	const productVideos = videoModal.querySelectorAll('tpt-live-item');

	if (video) {
		video.currentTime = 0;
		video.pause();
	}

	productVideos.forEach((product) => {
		product.classList.remove('playing');
	});

	clearInterval(checkPlayingInterval);
}

/**
 * Update product live variant sticky
 */
function updateProductLiveVariantStiky(productVariants) {
	const stickyVariantContainer = document.querySelector('[data-sticky-variants]');

	stickyVariantContainer.innerHTML = '';

	productVariants.forEach((variant) => {
		const variantLabel = variant.querySelector('input:checked').getAttribute('name');
		const variantValue = variant.querySelector('input:checked').getAttribute('value');
		const variantHtml = '<div class="variant-item"><span class="variant-name">' + variantLabel + '</span>: ' + variantValue + '</div>';

		stickyVariantContainer.insertAdjacentHTML('beforeend', variantHtml);
	});
}

/**
 * Show video modal
 */
if (!customElements.get('tpt-live-toggle')) {
	customElements.define(
		'tpt-live-toggle',
		class TptLiveToggle extends HTMLElement {
			constructor() {
				super();

				this.modalId = this.getAttribute('data-target');
				this.currentModal = document.getElementById(this.modalId);
				this.video = this.currentModal.querySelector('video');
				this.videoProducts = this.currentModal.querySelectorAll('tpt-live-item');

				this.addEventListener('click', this.toggleLiveModal.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.toggleLiveModal(e);
				}
			}

			/**
			 * Toggle modal
			 */
			toggleLiveModal() {
				/**
				 * Show modal
				 */
				document.getElementsByTagName('html')[0].classList.add('open-modal');
				this.currentModal.classList.add('show');

				setTimeout(() => {
					this.currentModal.focus();
				}, 300);

				if (this.video) {
					this.video.play();

					//checkPlayingInterval = setInterval(this.checkItemPlaying(), 1000);
					checkPlayingInterval = checkItemPlaying(this.video, this.videoProducts);
				}

				/**
				 * Get featured product
				 */
				if (this.currentModal.querySelector('[data-product-featured-handle]')) {
					this.getFeaturedProducts();
				}
			}

			/**
			 * Fetch featured products
			 */

			getFeaturedProducts() {
				const featuredElement = this.currentModal.querySelector('[data-product-featured-handle]');
				const productHandlesStr = featuredElement.getAttribute('data-product-featured-handle');
				const productHandlesArr = productHandlesStr.split(',');

				if (!featuredElement.classList.contains('product-loaded')) {
					productHandlesArr.forEach((productHandle) => {
						const fetchUrl = window.Shopify.routes.root + 'products/' + productHandle + '?section_id=tpt-product-live-card';

						fetch(fetchUrl)
							.then((response) => response.text())
							.then((responseText) => {
								const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
								const productElement = responseHTML.querySelector('.shopify-section');

								featuredElement.insertAdjacentHTML('beforeend', productElement.innerHTML);
							})
							.finally(() => {});
					});

					featuredElement.classList.add('product-loaded');
				}
			}
		}
	);
}

/**
 * Close live modal
 */

if (!customElements.get('tpt-close-live-modal')) {
	customElements.define(
		'tpt-close-live-modal',
		class TptCloseLiveModal extends HTMLElement {
			constructor() {
				super();

				this.currentModal = this.closest('tpt-live-modal');
				this.detailElement = this.currentModal.querySelector('[data-product-live-detail]');

				this.addEventListener('click', this.closeLiveModal.bind(this));
				this.addEventListener('keydown', this.closeModalComponentEsc.bind(this));
			}

			closeModalComponentEsc(e) {
				if (e.key === 'Enter') {
					this.closeLiveModal();
				}
			}

			closeLiveModal() {
				const itemBlockId = this.closest('tpt-live-modal').getAttribute('id');

				this.detailElement.innerHTML = '';
				resetVideoModal(this.currentModal);
				this.currentModal.classList.remove('show', 'product-video-loaded');
				document.getElementsByTagName('html')[0].classList.remove('open-modal');

				setTimeout(() => {
					document.querySelector(`tpt-live-toggle[data-target="${itemBlockId}"]`).focus();
				}, 200);
			}
		}
	);
}

/**
 * Play video item
 */

if (!customElements.get('tpt-live-product-play')) {
	customElements.define(
		'tpt-live-product-play',
		class TptPlayModalVideo extends HTMLElement {
			constructor() {
				super();

				this.currentModal = this.closest('tpt-live-modal');
				this.videoProducts = this.currentModal.querySelectorAll('tpt-live-item');
				this.video = this.currentModal.querySelector('video');
				this.currentItem = this.closest('tpt-live-item');
				this.addEventListener('click', this.playModalVideo.bind(this));

				this.addEventListener('keypress', this.keyPress.bind(this));
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.playModalVideo();
				}
			}

			playModalVideo() {
				const videoTimeStart = parseInt(this.getAttribute('data-time-start'));
				clearInterval(checkPlayingInterval);

				if (this.currentItem.classList.contains('playing')) {
					this.video.pause();
					this.currentItem.classList.remove('playing');

					return;
				} else {
					this.video.currentTime = videoTimeStart;
					this.video.play();

					this.resetItemVideo();

					//this.currentItem.classList.add('playing');

					checkPlayingInterval = checkItemPlaying(this.video, this.videoProducts);

					this.currentModal.classList.remove('show-video-sidebar');

					return;
				}
			}

			resetItemVideo() {
				const itemVideos = this.currentModal.querySelectorAll('tpt-live-item');

				itemVideos.forEach((item) => {
					item.classList.remove('playing');
				});
			}
		}
	);
}

/**
 * Render product detail
 */
if (!customElements.get('tpt-live-item-content')) {
	customElements.define(
		'tpt-live-item-content',
		class TptProductLiveDetail extends HTMLElement {
			constructor() {
				super();

				this.currentModal = this.closest('tpt-live-modal');
				this.video = this.currentModal.querySelector('video');
				this.detailElement = this.currentModal.querySelector('[data-product-live-detail]');
				this.fetchUrl = this.getAttribute('data-product-url');
				this.timeStartConfig = this.closest('tpt-live-item').getAttribute('data-time-start-config');
				this.timeStart = this.closest('tpt-live-item').getAttribute('data-time-item-start');

				this.addEventListener('click', this.renderProductDetail.bind(this));

				this.addEventListener('keypress', this.keyPress.bind(this));
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.renderProductDetail();
				}
			}

			renderProductDetail() {
				this.currentModal.classList.add('product-video-loaded');

				this.classList.add('loading');

				fetch(this.fetchUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
						const productElement = responseHTML.querySelector('.shopify-section');

						productElement.querySelector('tpt-live-product-play-trigger').setAttribute('data-time-start', this.timeStart);
						productElement.querySelector('[data-time-config]').innerHTML = this.timeStartConfig;

						this.detailElement.insertAdjacentHTML('beforeend', productElement.innerHTML);

						const productVariants = productElement.querySelectorAll('fieldset.product-form__input');

						if (productVariants) {
							updateProductLiveVariantStiky(productVariants);
						}
					})
					.finally(() => {
						this.classList.remove('loading');
					});
			}
		}
	);
}

/**
 * Back to list product in video
 */
if (!customElements.get('tpt-live-back')) {
	customElements.define(
		'tpt-live-back',
		class TptBackToVideoModal extends HTMLElement {
			constructor() {
				super();

				this.currentModal = this.closest('tpt-live-modal');
				this.detailElement = this.currentModal.querySelector('[data-product-live-detail]');

				this.addEventListener('click', this.backToVideoModal.bind(this));
				this.addEventListener('keypress', this.keyPress.bind(this));
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.backToVideoModal();
					this.currentModal.querySelector('.tpt-product-live__sidebar').focus();
				}
			}

			backToVideoModal() {
				this.currentModal.classList.remove('product-video-loaded');
				this.detailElement.innerHTML = '';
			}
		}
	);
}

/**
 * Button play in detail
 */
if (!customElements.get('tpt-live-product-play-trigger')) {
	customElements.define(
		'tpt-live-product-play-trigger',
		class TptPlayDetail extends HTMLElement {
			constructor() {
				super();

				this.currentModal = this.closest('tpt-live-modal');
				this.quickviewModal = this.closest('tpt-modal-component');

				if (this.currentModal) {
					this.video = this.currentModal.querySelector('video');
					this.videoProducts = this.currentModal.querySelectorAll('tpt-live-item');
					this.startTime = parseInt(this.getAttribute('data-time-start'));
				}

				this.addEventListener('click', this.playVideoDetail.bind(this));
				this.addEventListener('keypress', this.keyPress.bind(this));
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.playVideoDetail();
				}
			}

			playVideoDetail() {
				/**
				 * Play at time start only
				 */
				if (this.currentModal) {
					this.video.currentTime = this.startTime;
					this.video.play();
					this.currentModal.classList.remove('show-video-sidebar');
				} else {
					const videoId = this.getAttribute('data-video-id');
					const video = document.getElementById(videoId);
					const startTime = this.getAttribute('data-time-start');
					const quickviewModal = this.quickviewModal;

					video.currentTime = startTime;

					this.quickviewModal.classList.remove('show');
					video.play();

					setTimeout(function () {
						quickviewModal.remove();
					}, 400);
					//document.getElementsByTagName('html')[0].classList.remove('open-modal');
				}

				/*
				 * Play and pause
				 */
				/*
				if (this.classList.contains('started')) {
					if (this.classList.contains('playing')) {
						this.video.pause();
						this.classList.remove('playing');
						clearInterval(checkPlayingInterval);

						return;
					} else {
						this.video.play();
						this.classList.add('playing');
						clearInterval(checkPlayingInterval);
						checkPlayingInterval = checkItemPlaying(this.video, this.videoProducts);

						return;
					}

					return;
				} else {
					this.classList.add('started');
					this.classList.add('playing');
					this.video.currentTime = this.startTime;
					clearInterval(checkPlayingInterval);
					checkPlayingInterval = checkItemPlaying(this.video, this.videoProducts);

					return;
				}
				*/
			}
		}
	);
}

/**
 * Trigger sticky add to cart
 */
if (!customElements.get('tpt-trigger-add-cart')) {
	customElements.define(
		'tpt-trigger-add-cart',
		class TptCloseLiveModal extends HTMLElement {
			constructor() {
				super();

				this.currentModal = this.closest('tpt-live-modal');

				if (this.currentModal) {
					this.buttonAddToCart = this.currentModal.querySelector('.tpt-product-live__detail product-form .product-form__submit');
				}

				this.addEventListener('click', this.triggerAddToCart.bind(this));
				this.addEventListener('keypress', this.keyPress);
			}

			keyPress(e) {
				if (e.key === 'Enter') {
					this.triggerAddToCart();
				}
			}

			triggerAddToCart() {
				if (this.currentModal) {
					this.classList.add('loading');
					this.buttonAddToCart.click();
				}
			}
		}
	);
}

/**
 * Product live video modal
 */
if (!customElements.get('tpt-live-modal')) {
	customElements.define(
		'tpt-live-modal',
		class TptLiveModal extends HTMLElement {
			constructor() {
				super();

				this.currentModal = this.closest('tpt-live-modal');
				this.modalSidebar = this.currentModal.querySelector('.tpt-product-live__sidebar');

				this.modalSidebar.addEventListener('scroll', this.sidebarScroll.bind(this));

				this.addEventListener('keydown', this.keyDown.bind(this));
			}

			keyDown(e) {
				if (e.keyCode === 27) {
					this.querySelector('tpt-close-live-modal').closeLiveModal();
				}

				if (e.keyCode === 9) {
					const currentModal = this.currentModal;

					setTimeout(() => {
						const focusItem = document.activeElement;

						if (!focusItem.closest('tpt-live-modal')) {
							currentModal.querySelector('[tabindex]').focus();
						}
					}, 50);
				}
			}

			sidebarScroll() {
				const buttonAddToCart = this.currentModal.querySelector('product-form .product-form__submit');

				if (buttonAddToCart) {
					const buttonOffset = buttonAddToCart.offsetTop + 500;
					const stickyHeight = this.modalSidebar.querySelector('.tpt-product-live__sticky').offsetHeight;

					this.modalSidebar.setAttribute('style', '--padding-bottom-sticky:' + stickyHeight + 'px');

					if (this.modalSidebar.scrollTop > buttonOffset) {
						this.modalSidebar.classList.add('sticky--add-to-cart');
					} else {
						this.modalSidebar.classList.remove('sticky--add-to-cart');
					}
				}
			}
		}
	);
}

/**
 * Toggle video menu sidebar
 */
if (!customElements.get('tpt-toggle-video-menu')) {
	customElements.define(
		'tpt-toggle-video-menu',
		class TptToggleSidebarMenu extends HTMLElement {
			constructor() {
				super();

				this.currentModal = this.closest('tpt-live-modal');

				this.addEventListener('click', this.toggleVideoMenu.bind(this));
			}

			toggleVideoMenu() {
				this.currentModal.classList.toggle('show-video-sidebar');
			}
		}
	);
}

/**
 * Toggle video menu sidebar
 */
if (!customElements.get('tpt-product-mobile-video')) {
	customElements.define(
		'tpt-product-mobile-video',
		class TptProductMobile extends HTMLElement {
			constructor() {
				super();

				this.currentModal = this.closest('tpt-live-modal');
				const firstItemImage = this.currentModal.querySelector('tpt-live-item-content .tpt-product-live_image');
				const firstItemInfo = this.currentModal.querySelector('tpt-live-item-content .tpt-product-live_info');

				const firstItemId = this.currentModal.querySelector('tpt-live-item-content').getAttribute('data-product-id');
				const firstItemAjaxurl = this.currentModal.querySelector('tpt-live-item-content').getAttribute('data-product-url');

				const videoStartConfig = this.currentModal.querySelector('tpt-live-item-content').getAttribute('data-video-start-config');
				const videoStart = this.currentModal.querySelector('tpt-live-item-content').getAttribute('data-video-item-start');
				const videoId = this.currentModal.querySelector('tpt-live-item-content').getAttribute('data-video-id');

				const mobileImageElement = this.querySelector('.tpt-product-live__mobile-image');
				const mobileInfoElement = this.querySelector('.tpt-product-live__mobile-info');

				if (firstItemImage && firstItemInfo) {
					mobileImageElement.innerHTML = firstItemImage.innerHTML;
					mobileInfoElement.innerHTML = firstItemInfo.innerHTML;
					this.setAttribute('data-product-id', firstItemId);
					this.setAttribute('data-product-url', firstItemAjaxurl);

					this.setAttribute('data-video-start-config', videoStartConfig);
					this.setAttribute('data-video-item-start', videoStart);
					this.setAttribute('data-video-id', videoId);
				}

				this.addEventListener('click', this.mobileProductView.bind(this));
			}

			mobileProductView() {
				const productUrl = this.getAttribute('data-product-url');
				const productId = this.getAttribute('data-product-id');
				const timeStartConfig = this.getAttribute('data-video-start-config');
				const timeStart = this.getAttribute('data-video-item-start');
				const videoId = this.getAttribute('data-video-id');

				const productTitle = '';

				let modalHtml = '';
				modalHtml += '<tpt-modal-component id="product-live-modal_id-' + productId + '" class="quickview-modal tpt-product-live__modal fade" data-position="bottom" role="dialog" aria-modal="true" tabindex="0">';
				modalHtml += '<tpt-modal-dialog class="color-scheme-1 gradient">';
				modalHtml += '<tpt-modal-content>';

				modalHtml += '<tpt-modal-header>';
				modalHtml += '<div class="modal-title">';
				modalHtml += productTitle;
				modalHtml += '</div>';

				modalHtml += '<button class="close-modal" data-close="modal" tabindex="0">';
				modalHtml += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path></svg>';
				modalHtml += '</button>';
				modalHtml += '</tpt-modal-header>';

				modalHtml += '<tpt-modal-body>';
				modalHtml += '<div class="modal-body_data-ajax modal-body_loading">';
				modalHtml += '<div class="loader-component"><span class="hidden">Loading...</span></div>';
				modalHtml += '</div>';
				modalHtml += '</tpt-modal-body>';

				modalHtml += '</tpt-modal-content>';
				modalHtml += '</tpt-modal-dialog>';
				modalHtml += '</tpt-modal-component>';

				document.body.insertAdjacentHTML('beforeend', modalHtml);
				document.getElementsByTagName('html')[0].classList.add('open-modal');

				setTimeout(function () {
					document.getElementById('product-live-modal_id-' + productId).classList.add('show');
				}, 200);

				fetch(productUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const productModal = document.getElementById('product-live-modal_id-' + productId);
						const productContainer = productModal.querySelector('.modal-body_data-ajax');
						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
						const productElement = responseHTML.querySelector('.shopify-section');

						if (responseHTML.querySelector('variant-selects')) {
							const sectionId = responseHTML.querySelector('variant-selects').getAttribute('data-section');

							productContainer.innerHTML = productElement.innerHTML.replaceAll(sectionId, `tpt-quickview-${sectionId}`);
						} else {
							productContainer.innerHTML = productElement.innerHTML;
						}

						productContainer.querySelector('.tpt-time-video').innerHTML = timeStartConfig;
						productContainer.querySelector('tpt-live-product-play-trigger').setAttribute('data-time-start', timeStart);
						productContainer.querySelector('tpt-live-product-play-trigger').setAttribute('data-video-id', videoId);

						//productContainer.innerHTML = productElement.innerHTML;

						productContainer.querySelectorAll('script').forEach((oldScriptTag) => {
							const newScriptTag = document.createElement('script');
							Array.from(oldScriptTag.attributes).forEach((attribute) => {
								newScriptTag.setAttribute(attribute.name, attribute.value);
							});
							newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
							oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
						});
					})
					.finally(() => {});
			}
		}
	);
}

/**
 * Link choose options
 */
if (!customElements.get('tpt-choosse-option')) {
	customElements.define(
		'tpt-choosse-option',
		class TptChooseOptions extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.chooseOptions.bind(this));
			}

			chooseOptions() {
				const sidebarModal = this.closest('tpt-live-modal').querySelector('.tpt-product-live__sidebar');
				const chooseFormField = sidebarModal.querySelector('tpt-product-live-variant');
				const formFieldOffsetTop = chooseFormField.offsetTop - 150;

				sidebarModal.scroll({
					top: formFieldOffsetTop,
					behavior: 'smooth',
				});

				// sidebarModal.animate(
				// 	{
				// 		scrollTop: chooseFormField.offsetTop,
				// 	},
				// 	1000
				// );
			}
		}
	);
}
